"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _ikon = _interopRequireDefault(require("./ikon"));
const ArrowDown2 = _ref => {
  let {
    title = "Down Arrow",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, props, {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }), /*#__PURE__*/_react.default.createElement("title", null, title), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.5 3.9h3v18.2l8.3-8.3l2.2 2.2l-12 12l-12-12l2.2-2.2l8.3 8.3V3.9z"
  }));
};
var _default = exports.default = (0, _ikon.default)(ArrowDown2);
ArrowDown2.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ArrowDown2",
  "props": {
    "title": {
      "defaultValue": {
        "value": "\"Down Arrow\"",
        "computed": false
      },
      "required": false
    }
  }
};